module.exports = __webpack_public_path__ + "img/494.6980346b.jpg";